import type { NotificationResponseBasicInfoAllOf } from './notificationResponseBasicInfoAllOf';
import type { NotificationResponseBasicInfoAllOfTwo } from './notificationResponseBasicInfoAllOfTwo';

export type NotificationResponseBasicInfo = NotificationResponseBasicInfoAllOf & NotificationResponseBasicInfoAllOfTwo;
